/**
 * Production env variable values (prd for client package and production for all other packages)
 */
const PROD_ENVIRONMENTS = ['prd', 'production']

/**
 * Checks whether the passed environment variable value matches the production value.
 * @param appEnv The environment variable value to check
 */
export const getIsProductionAppEnv = (appEnv?: string) => {
  return appEnv ? PROD_ENVIRONMENTS.includes(appEnv) : false
}
